import slug from "slug";
import ArrowPurpleIcon from "@/assets/icons/arrow-purple.svg";
import { useRouter } from "next/navigation";

export default function ActiveLocationCta({
  activeLocation,
  selectedLocationDetail,
  hoverColor,
}) {
  const router = useRouter();
  const locationMap = {
    london: "london-uk",
    bristol: "bristol-uk",
    munich: "munich-de",
    berlin: "berlin-uk",
    "new-york": "new-york-usa",
    miami: "miami-usa",
    austin: "austin-usa",
    "los-angeles": "los-angeles-usa",
  };

  return (
    <div
      onClick={() =>
        router.push(`/contact#${locationMap[slug(activeLocation)]}`)
      }
      className="sm:basis-1/3 group/item relative cursor-pointer m-auto sm:m-0 flex flex-col justify-center items-center sm:items-start max-w-[414px] sm:max-h-[607px]"
    >
      <div className="h-full w-full bg-pink text-purple p-8">
        <h3 className={`text-[40px] max-w-[260px] ${hoverColor}`}>
          Get in touch with our {activeLocation} office.
        </h3>
        <div className="pt-8">
          <p className={`text-[16px] ${hoverColor} text-center sm:text-start`}>
            Phone
          </p>
          <p className={`text-[20px] ${hoverColor} text-center sm:text-start`}>
            {selectedLocationDetail?.tel}
          </p>
        </div>
        {selectedLocationDetail?.email && (
          <div className="pt-4">
            <p
              className={`text-[16px] ${hoverColor} text-center sm:text-start`}
            >
              Email
            </p>
            <p
              className={`text-[20px] ${hoverColor} text-center sm:text-start`}
            >
              {selectedLocationDetail?.email}
            </p>
          </div>
        )}
        <div className="pt-4 max-w-[300px]">
          <p className={`text-[16px] ${hoverColor} text-center sm:text-start`}>
            Address
          </p>
          <p className={`text-[20px] ${hoverColor} text-center sm:text-start`}>
            {selectedLocationDetail?.address}
          </p>
        </div>

        <div className="w-[49px] h-[49px] text-[#1B0D34] bg-white hidden group-hover/item:flex justify-center items-center absolute bottom-0 right-0">
          <ArrowPurpleIcon />
        </div>
      </div>
    </div>
  );
}
